import { sanitize } from "./helpers";
import { Tag } from "./models";
import { notEmptyString } from "./validators";

export const extractHashTags = (text: string): string[] => {
  if (notEmptyString(text)) {
    return text
      .split(/\b[^\w_-]/)
      ?.filter((w) => w.startsWith("#"))
      .map((s: string) => s.trim());
  } else {
    return [];
  }
};

export const isUpperCase = (char: string): boolean => {
  const rgx = /[A-ZÄÀÁÂÃÈÉËÊÎÏÌÍÑÖÒÓÕÜÙÚ]/;
  return rgx.test(char);
};

export const isSeparator = (char: string): boolean => {
  return ["-", "_"].includes(char);
};

const expandTag = (tag: string): string => {
  const chars = tag.split("");
  chars.shift();
  const lastIndex = chars.length - 1;
  const mayCastToLower = !isUpperCase(chars[0]);
  return chars
    .map((char, ci) => {
      if (ci > 0) {
        const pc = chars[ci - 1];
        if ((isUpperCase(char) && !isUpperCase(pc)) || isSeparator(char)) {
          let toLower = mayCastToLower && ci === lastIndex;
          if (mayCastToLower && ci < lastIndex) {
            const nc = chars[ci + 1];
            toLower = !isUpperCase(nc);
          }
          const newChar = isSeparator(char) ? "" : char;
          return toLower ? " " + newChar.toLowerCase() : " " + newChar;
        }
      }
      return char;
    })
    .join("");
};

export const extractAllTags = (text: string): string => {
  const rgx = /(<span class="tag">(.*?)<\/span>)/gi;
  if (notEmptyString(text)) {
    const matches = text.match(rgx);
    if (matches instanceof Array) {
      matches.forEach((m) => {
        const tg = m
          .replace(rgx, "$2")
          .split(" ")
          .map((w, wi) => {
            if (wi > 0) {
              return w.substring(0, 1).toUpperCase() + w.substring(1);
            } else {
              return w;
            }
          })
          .join("");
        text = text.replace(m, "#" + tg);
      });
    }
  }
  return text;
};

export const highlightTags = (text: string): string => {
  if (notEmptyString(text) && text.indexOf("#")) {
    const tags = extractHashTags(text);
    tags.forEach((tg) => {
      const term = expandTag(tg);
      text = text.replace(
        new RegExp(tg + "\\b"),
        `<span class="tag">${term}</span>`
      );
    });
  }
  return text;
};

const hasTagSpan = (text: string) =>
  text.includes("<span") && /class="tag"/.test(text);

export const extractTagItems = (text: string): Tag[] => {
  const refText = hasTagSpan(text) ? extractAllTags(text) : text;
  return extractHashTags(refText).map((str: string) => {
    const term = expandTag(str);
    const slug = sanitize(term);
    return new Tag({
      text: term,
      slug,
    });
  });
};
